// For LocalServer
// const apiBaseUrl = 'http://localhost:5000';

//For live
const apiBaseUrl = 'https://api.cashflow.cmtprooptiki.gr:4002';

export default apiBaseUrl;